export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const FLUSH_NOTIFICATIONS = 'FLUSH_NOTIFICATIONS';
export const HIDE_NOTIFICATIONS_CENTER = 'HIDE_NOTIFICATIONS_CENTER';
export const SHOW_NOTIFICATIONS_CENTER = 'SHOW_NOTIFICATIONS_CENTER';
